import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SkipSuccessToastInterceptor, SkipToastInterceptor } from '@app/helpers/skip-toast';
import { ToastHandlerService } from '@app/shared/services/toast-handler.service';

export const toastHandlerInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toast = inject(ToastHandlerService);

  const hasSkipToast = request.headers.has(SkipToastInterceptor);
  const hasSkipSuccessToast = request.headers.has(SkipSuccessToastInterceptor);
  let headers = request.headers;

  if (hasSkipToast) {
    headers = request.headers.delete(SkipToastInterceptor).delete(SkipSuccessToastInterceptor);
    return next(request.clone({ headers }));
  }

  if (hasSkipSuccessToast) {
    headers = request.headers.delete(SkipSuccessToastInterceptor);
  }

  return next(request.clone({ headers })).pipe(
    map(event => {
      if (event instanceof HttpResponse) {
        if (request.method === 'PUT' || request.method === 'DELETE' || request.method === 'POST' || request.method === 'PATCH') {
          if (request.url.includes('/auth/refresh')) {
            return event;
          } else {
            // 204 responses don't have a body.message, so this would throw an error.
            if (`${event.status}`.startsWith('2') && event.status !== 204 && !hasSkipSuccessToast) {
              toast.showSuccessToastsResponse((event.body as { message: string }).message);
            }
          }
        }
      }
      return event;
    }),
    catchError(err => {
      // do not display errors on token expirations and when error contains blob details on file response errors
      if (!err.error?.token_expired && !(err.error instanceof Blob)) {
        try {
          toast.showErrorToastsResponse(err);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
      return throwError(() => err);
    }),
  );
};
